import * as React from 'react'
import { GrPrice } from '../../../../../../../utilities/helpers'

interface Props {
  enteredQuantity: number | null
  expectedQuantity: number | null
}

export const AuditDiscrepancy = (props: Props) => {
  const { enteredQuantity, expectedQuantity } = props
  const stringDiscrepancy = ((enteredQuantity || 0) - (expectedQuantity || 0)).toFixed(4)
  const discrepancy = parseFloat(stringDiscrepancy)
  const stringDiscrepancyWithComma = GrPrice.convertDecimalString(discrepancy, 0, 2)

  let spanClassName: string
  let spanContent: string | number

  switch (true) {
    case enteredQuantity === null:
      spanClassName = 'text-muted'
      spanContent = '-'
      break
    case discrepancy >= 0:
      spanClassName = 'text-success'
      spanContent = stringDiscrepancyWithComma
      break
    default:
      spanClassName = 'text-danger'
      spanContent = discrepancy > 0 ? `+${stringDiscrepancyWithComma}` : stringDiscrepancyWithComma
  }

  return <span className={spanClassName}>{spanContent}</span>
}
